export default function getExplainerBlockData(props) {
  const {
    explainerQuoteText,
    explainerQuoteAuthor,
    explainerContentTitle,
    explainerContentText,
    explainerContentTextAfterQuote,
    explainerInfographicMobile,
    explainerInfographicDesktop,
  } = props;

  const data = {};

  data.quote = explainerQuoteText || false;
  data.author = explainerQuoteAuthor?.fields ? {} : false;
  if (data.author) {
    data.author.name = explainerQuoteAuthor?.fields?.fullName ? explainerQuoteAuthor.fields.fullName : false;
    data.author.jobtitle = explainerQuoteAuthor?.fields?.jobTitle ? explainerQuoteAuthor.fields.jobTitle : false;
    data.author.avatar = explainerQuoteAuthor?.fields?.avatar ? {} : false;
    data.author.avatar.image = explainerQuoteAuthor?.fields?.avatar?.fields?.file?.url
      ? explainerQuoteAuthor.fields.avatar.fields.file.url
      : false;
    data.author.avatar.width = explainerQuoteAuthor?.fields?.avatar?.fields?.file?.details?.image?.width
      ? explainerQuoteAuthor.fields.avatar.fields.file.details.image.width
      : false;
    data.author.avatar.height = explainerQuoteAuthor?.fields?.avatar?.fields?.file?.details?.image?.height
      ? explainerQuoteAuthor.fields.avatar.fields.file.details.image.height
      : false;
  }

  data.title = explainerContentTitle || false;
  data.content = explainerContentText || false;
  data.contentAfterQuote = explainerContentTextAfterQuote || false;

  data.infographic = explainerInfographicMobile?.fields && explainerInfographicDesktop?.fields ? {} : false;
  if (data.infographic) {
    data.infographic.desktop = explainerInfographicDesktop?.fields?.file?.url ? {} : false;
    if (data.infographic.desktop) {
      data.infographic.desktop.src = explainerInfographicDesktop?.fields?.file?.url;
      data.infographic.desktop.alt = explainerInfographicDesktop?.fields?.title || '';
      data.infographic.desktop.width = explainerInfographicDesktop?.fields?.file?.details?.image?.width || false;
      data.infographic.desktop.height = explainerInfographicDesktop?.fields?.file?.details?.image?.height || false;
    }

    data.infographic.mobile = explainerInfographicMobile?.fields?.file?.url ? {} : false;
    if (data.infographic.mobile) {
      data.infographic.mobile.src = explainerInfographicMobile?.fields?.file?.url;
      data.infographic.mobile.alt = explainerInfographicMobile?.fields?.title || '';
      data.infographic.mobile.width = explainerInfographicMobile?.fields?.file?.details?.image?.width || false;
      data.infographic.mobile.height = explainerInfographicMobile?.fields?.file?.details?.image?.height || false;
    }
  }

  return Object.keys(data).length ? data : false;
}
